import { createFileRoute } from "@tanstack/react-router";

import { getJobPostings } from "@/lib/jobPostings";
import { CareerPageContent } from "../career";

export const Route = createFileRoute("/en/career")({
	loader: async () => {
		const positions = await getJobPostings("en");
		return { positions };
	},
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{ title: "Career | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Join the team of Makedonijaturist AD. Open job positions in the largest hotel group in Skopje. Build your career with us.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/career",
			},
		],
	}),
	component: EnCareerPage,
});

function EnCareerPage() {
	const { positions } = Route.useLoaderData();
	return <CareerPageContent positions={positions} />;
}
